// import api from "@/services/api";

import api from "@/services/api";

const initialState = () => ({
  nft: {
    id: null,
    name: "",
    royaltyPercentage: null,
    isExplicit: false,
    coverImageURL: "",
    description: "",
    alternativeDescription: "",
    unlockableContent: null,
    tags: [],
    creator: {},
    owners: [],
    contractAddress: "",
    status: "",
    coverImage: {
      path: "",
      fileName: "",
    },
    file: {
      filename: "",
      path: "",
      mimeType: "",
    },
    pooled: false,
  },
  errors: [],
});

const state = initialState();

const getters = {
  getByKey: (state) => (key) => state.nft[key],
  getNft: (state) => state.nft,
};

const mutations = {
  commitByKey(state, object) {
    Object.keys(object.nft).forEach((key) => {
      state.nft[key] = object.nft[key];
    });
  },
  pushError(state, error) {
    state.errors.push(error);
  },
  resetState(state) {
    Object.assign(state, initialState());
  },
};
const actions = {
  commitByKey({ commit }, object) {
    commit("commitByKey", object);
  },
  resetState({ commit }) {
    commit("resetState");
  },
  async fetchNft({ commit }, id) {
    try {
      const response = await api.fetchNft(id);
      commit("commitByKey", { nft: response.data });
      return response;
    } catch (error) {
      commit("pushError", error);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
